var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('current-month-consumption',_vm._b({on:{"calculation-error":function($event){return _vm.$emit('calculation-error')}}},'current-month-consumption',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }